import "core-js/stable";
import "common/util/polyfill";
import React from "react";
import ReactDOM from "react-dom";
import { IntlProvider } from "react-intl";

import App from "wxrecall/components/App";
import { defaultSettings } from "wxrecall/util/defaults";

import messagesFr from "workspace/translations/fr.json";
import messagesEn from "workspace/translations/en.json";
import { deserializeColourCurves } from "workspace/util/colourizer";
import { deserializeTemperatureCurves } from "workspace/util/temperatureScales";

const messages = {
  fr: messagesFr,
  en: messagesEn
};

const settings = window.settings || defaultSettings;

settings.colourCurves = {};
try {
  settings.colourCurves = deserializeColourCurves(
    settings.language,
    settings.colourCurveJson
  );
} catch (error) {
  console.warn(error);
}

try {
  settings.workspace.temperatureCurves = deserializeTemperatureCurves(
    settings.workspace.temperatureCurveJson
  );
} catch (error) {
  console.warn(error);
}

ReactDOM.render(
  <IntlProvider
    locale={settings.language}
    messages={messages[settings.language]}
  >
    <App />
  </IntlProvider>,
  document.getElementById("root")
);
